import { useSelector } from 'react-redux'

import { checkReadOnlyAccess } from 'clickNgo/helpers/access'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'

export const useCheckReadOnlyAccess = () => {
  const user = useSelector(selectUser)

  return checkReadOnlyAccess(user)
}
